// extracted by mini-css-extract-plugin
export var orange = "Social-module--orange--4a741";
export var socialIcons = "Social-module--social-icons--e956f";
export var socialMedia = "Social-module--social-media--77b03";
export var thin = "Social-module--thin--18497";